var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('img',{staticClass:"error-icon",attrs:{"src":require("@/assets/icon/tip.svg"),"alt":""}}),_c('span',{staticClass:"error-err"},[_vm._v("提示")]),_c('div',{staticClass:"error-msg"},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }